//componente

import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { CrudMasterDetailView, GridView, CompositeView, CrudContext, CrudMasterDetailViewPaginated } from '@digital/ui';
import { useRecoilState } from 'recoil';
import { medicaoIdState, medicaoSelectedState } from './atoms';
import { useRouter } from '@digital/ui';
//api
import {
  updateMedicao,
  VerificarSeUsuarioPodeEditarMedicao,
  VerificarSeuUsuarioLogadoGestorMrnSessao,
  VerificarSeUsuarioLogadoAdministradorDoContatoSessao,
  VerificarSeUsuarioLogadoFiscalDoContrato,
  VerificarSeUsuarioLogadoFiscalAlternativoDoContrato,
  VerificarSeUsuarioLogadoAdministradorAlternativoDoContratoMrn,
  VerificarSeUsuarioLogadoFiscalDoContratoFornecedor,
  VerificarSeUsuarioLogadoGestorDoContratoFornecedor,
  VerificarSeUsuarioLogadoTecnicoMedicaoMrn,
  VerificarSeUsuarioLogadoTemPermissaoEditarNiveis,
  ResumoMedicaoList,
  VerificarSeUsuarioLogadoFinanceiroDoContratoFornecedor,
  GetAllToMenu,
  GetSelectedFromMenu,
  GetAllBoletimMedicao,
} from '@app/api/boletimMedicao';

// importar abas
import AbaMedicao from './Medicao';
import AbaGeral from './Geral';
import AbaSla from './Sla';
import AbaPendencias from './pendencias';
import AutorizacaoPagamento from './AutorizacaoPagamento';
import AbaHistorico from './Historico';
import AbaTimeLine from './Timeline';
import { hasPermission } from '@app/helpers/permissions';
import { getLoggedIsMRN } from '@app/helpers';
import AbaRateio from './Rateio';
import { compareStringSlug } from '@app/helpers/stringHelper';
import { isObjNotEmpty } from '@app/helpers/objHelper';

const BoletimMe = () => {
  const [clicavel, setClicavel] = useState(true);
  const [medicaoSelected, setMedicaoSelected] = useRecoilState(medicaoSelectedState);
  const pathParts = window.location.pathname.split('/');
  const [medicaoId, setMedicaoId] = useRecoilState(medicaoIdState);
  const medicaoContratoId = pathParts[4];

  if (window.location.pathname.split('/')[3]) {
    setMedicaoId(window.location.pathname.split('/')[3]);
  }

  const [GetAllItems, setGetAllItems] = useState(() => {
    // return GetAllBoletimMedicao
    if (medicaoContratoId) {
      return () => GetAllToMenu(medicaoContratoId);
    }
    return GetAllToMenu;
  });
  const { history } = useRouter();

  //#region INFINITY SCROLL

  // const [allItems, setAllItems] = useState<any[]>([]);
  // const [searchList, setSearchList] = useState<any[]>([]);
  // const [infiniteScroll, setInfiniteScroll] = useState<any[]>([]);
  // const getAllBM = useCallback(() => new Promise<any[]>((resolve, reject) => {
  //   resolve([]);
  // }), []);

  // const getAllItems = async () => {
  //   const dataTemp = await GetAllToMenu();
  //   if (dataTemp) {
  //     setAllItems(dataTemp);
  //     setSearchList(dataTemp);
  //     setInfiniteScroll(dataTemp.slice(0, 50));
  //   }
  // }

  // useEffect(() => {
  //   getAllItems();
  // }, [])

  // const handleUpdate = () => {
  //   getAllItems();
  // };

  // const onScroll = (value: number) => {
  //   if (searchList.length > infiniteScroll.length) {
  //     if (value > 0) {
  //       const size = infiniteScroll.length;
  //       setInfiniteScroll(infiniteScroll.concat(searchList.slice(size, size + 50)));
  //     }
  //   }
  // }

  // const onSearch = (value: string) => {
  //   if (value) {
  //     const newList = [...allItems.filter((item) =>
  //       compareStringSlug(item.numeroDoContrato.toString(), value)
  //       || compareStringSlug(item.numero.toString(), value)
  //       || compareStringSlug(item.escopo, value)
  //       || compareStringSlug(item.nomeDoFornecedor, value))];
  //     setSearchList(newList);
  //     setInfiniteScroll(newList.slice(0, 50));
  //   } else {
  //     setSearchList(allItems);
  //     setInfiniteScroll(allItems.slice(0, 50));
  //   }

  //   return true;
  // };
  // #endregion

  const [isMRN] = useState<boolean>(getLoggedIsMRN());

  const [hasPendenciasAba, setHasPendenciasAba] = useState(false);

  const [atualizarSla, setAtualizarSla] = useState(false);
  const [atualizarMedicao, setAtualizarMedicao] = useState(false);

  const [usuarioPodeEditarMedicao, setusuarioPodeEditarMedicao] = useState(false);

  const [usuarioLogadoGestorDoContratoMrn, setusuarioLogadoGestorDoContratoMrn] = useState(false);
  const [usuarioLogadoFiscalDoContratoMrn, setusuarioLogadoFiscalDoContratoMrn] = useState(false);
  const [usuarioLogadoFiscalAlternativoDoContratoMrn, setusuarioLogadoFiscalAlternativoDoContratoMrn] = useState(false);
  const [
    usuarioLogadoAdministradorAlternativoDoContratoMrn,
    setusuarioLogadoAdministradorAlternativoDoContratoMrn,
  ] = useState(false);
  const [usuarioLogadoAdministradorDoContratoMrn, setusuarioLogadoAdministradorDoContratoMrn] = useState(false);

  const [usuarioLogadoFiscalDoContratoFornecedor, setusuarioLogadoFiscalDoContratoFornecedor] = useState(false);
  const [usuarioLogadoGestorDoContratoFornecedor, setusuarioLogadoGestorDoContratoFornecedor] = useState(false);
  const [usuarioLogadoFinanceiroDoContratoFornecedor, setusuarioLogadoFinanceiroDoContratoFornecedor] = useState(false);
  const [usuarioLogadoFinanceiroFiscalGestorDoContratorFornecedor, setUsuarioLogadoFinanceiroFiscalGestorDoContratorFornecedor] = useState(false);

  const [usuarioLogadoTecnicoMedicaoMrn, setUsuarioLogadoTecnicoMedicaoMrn] = useState(false);
  const [atualizarFormulario, setAtualizarFormulario] = useState(false);

  const [usuarioResponsavelDiretoria, setUsuarioResponsavelDiretoria] = useState(false);
  const [usuarioResponsavelArea, setUsuarioResponsavelArea] = useState(false);
  const [usuarioResponsavelDepartamento, setUsuarioResponsavelDepartamento] = useState(false);

  const AtualizarFormularioAbas = () => {
    setAtualizarFormulario(true);
    setAtualizarFormulario(false);
  };

  const handleCreateAba = () => {
    setHasPendenciasAba(false);
    setHasPendenciasAba(true);
  };

  const handleRemoveAba = () => {
    setHasPendenciasAba(true);
    setHasPendenciasAba(false);
  };

  const handleUpdate = () => {
    GetAllToMenu().then(data => {
      if (data) {
        setGetAllItems(data);
      }
    });
  };

  const AtualizarAbaSla = () => {
    setAtualizarSla(!atualizarSla);
  };

  const AtualizarAbaMedicao = () => {
    setAtualizarMedicao(!atualizarMedicao);
    handleUpdate();
  };

  const AtualizarPagina = () => {
    location.reload();
  };

  const onUpdateMedicao = (values: any) => {
    return updateMedicao(values).then(resp => {
      if (resp.valid) {
        handleUpdate();
      }
      return resp;
    });
  };

  const VerificarSeUsuarioLogadoPodeEditarMedicao = (medicao?: ResumoMedicaoList | null) => {
    if (!medicao) return false;
    if (!isObjNotEmpty(medicaoSelected)) return false;

    if (medicao) {
      VerificarSeUsuarioPodeEditarMedicao(medicao.id).then(data => {
        data === true ? setusuarioPodeEditarMedicao(true) : setusuarioPodeEditarMedicao(false);
      });
      VerificarSeuUsuarioLogadoGestorMrnSessao(medicao.id).then(data => {
        data === true ? setusuarioLogadoGestorDoContratoMrn(true) : setusuarioLogadoGestorDoContratoMrn(false);
      });

      VerificarSeUsuarioLogadoAdministradorDoContatoSessao(medicao.id).then(data => {
        data === true
          ? setusuarioLogadoAdministradorDoContratoMrn(true)
          : setusuarioLogadoAdministradorDoContratoMrn(false);
      });

      VerificarSeUsuarioLogadoFiscalDoContrato(medicao.id).then(data => {
        data === true ? setusuarioLogadoFiscalDoContratoMrn(true) : setusuarioLogadoFiscalDoContratoMrn(false);
      });

      VerificarSeUsuarioLogadoFiscalAlternativoDoContrato(medicao.id).then(data => {
        data === true
          ? setusuarioLogadoFiscalAlternativoDoContratoMrn(true)
          : setusuarioLogadoFiscalAlternativoDoContratoMrn(false);
      });

      VerificarSeUsuarioLogadoAdministradorAlternativoDoContratoMrn(medicao.id).then(data => {
        data === true
          ? setusuarioLogadoAdministradorAlternativoDoContratoMrn(true)
          : setusuarioLogadoAdministradorAlternativoDoContratoMrn(false);
      });

      //Fornecedor

      VerificarSeUsuarioLogadoFiscalDoContratoFornecedor(medicao.id).then(data => {
        data === true
          ? setusuarioLogadoFiscalDoContratoFornecedor(true)
          : setusuarioLogadoFiscalDoContratoFornecedor(false);
      });

      VerificarSeUsuarioLogadoGestorDoContratoFornecedor(medicao.id).then(data => {
        data === true
          ? setusuarioLogadoGestorDoContratoFornecedor(true)
          : setusuarioLogadoGestorDoContratoFornecedor(false);
      });

      VerificarSeUsuarioLogadoFinanceiroDoContratoFornecedor(medicao.id).then(data => {
        data === true
          ? setusuarioLogadoFinanceiroDoContratoFornecedor(true)
          : setusuarioLogadoFinanceiroDoContratoFornecedor(false);
      });

      VerificarSeUsuarioLogadoTecnicoMedicaoMrn(medicao.id).then(data => {
        data === true ? setUsuarioLogadoTecnicoMedicaoMrn(true) : setUsuarioLogadoTecnicoMedicaoMrn(false);
      });

      VerificarSeUsuarioLogadoTemPermissaoEditarNiveis(medicao.id).then(data => {
        if (data) {
          setUsuarioResponsavelDiretoria(data.usuarioResponsavelDiretoriaPossuiPermissao);
          setUsuarioResponsavelArea(data.usuarioResponsavelAreaPossuiPermissao);
          setUsuarioResponsavelDepartamento(data.usuarioResponsavelDepartamentoPossuiPermissao);
        }
      });
    }
    return true;
  };

  useEffect(() => {
  if (usuarioLogadoFiscalDoContratoFornecedor || 
      usuarioLogadoGestorDoContratoFornecedor || 
      usuarioLogadoFinanceiroDoContratoFornecedor) {
    setUsuarioLogadoFinanceiroFiscalGestorDoContratorFornecedor(true);
  } else {
    setUsuarioLogadoFinanceiroFiscalGestorDoContratorFornecedor(false);
  }
}, [
  usuarioLogadoFiscalDoContratoFornecedor, 
  usuarioLogadoGestorDoContratoFornecedor, 
  usuarioLogadoFinanceiroDoContratoFornecedor
]);

  useEffect(() => {
    if (medicaoId) {
      GetSelectedFromMenu(medicaoId).then(data => {
        if (data) {
          setMedicaoSelected(data);
          if (medicaoContratoId) {
            history.push(`/boletimDeMedicoes/detail/${medicaoId}`);
          }
        }
      });
    }
  }, [medicaoId]);

  const usuarioPodeEditar = useMemo(() => {
    if (!medicaoSelected) return false;
    return VerificarSeUsuarioLogadoPodeEditarMedicao(medicaoSelected);
  }, [medicaoSelected]);

  return (
    <>
      <CrudMasterDetailViewPaginated
        pageSize={100}
        // infinityItems={infiniteScroll}
        // filterInfinity={onSearch}
        // onYReachEnd={onScroll}
        // getAllItems={getAllBM}
        // filterPredicate={(item: any, value: string) => true}
        getAllItems={GetAllItems}
        updateItem={onUpdateMedicao}
        titleExtractor={item =>
          `${item.numeroDoContrato}${item.identificadorPq ? ' - PQ ' + item.identificadorPq : ''} - BM ${item.numero}${
            item.escopo ? ' - ' + item.escopo : ''
          } - ${item.nomeDoFornecedor}`
        }
        icon="printing-ruler"
        filterPredicate={(item, value) =>
          compareStringSlug(item.numeroDoContrato.toString(), value) ||
          compareStringSlug(item.numero.toString(), value) ||
          compareStringSlug(item.escopo, value) ||
          compareStringSlug(item.nomeDoFornecedor, value)
        }
        descriptionExtractor={item => 'De: ' + item.periodoInicio + ' Até: ' + item.periodoFim}>
        <CrudContext.Consumer>
          {({ selectedItem }) => (
            <CompositeView>
              {hasPermission(['MEDICAO_QUANTITATIVA_VISUALIZAR_ABA']) &&
              isObjNotEmpty(medicaoSelected) &&
              usuarioPodeEditar ? (
                <GridView icon="ui-info" id="geral" noform title="Geral">
                  <AbaGeral
                    onUpdate={AtualizarAbaSla}
                    atualizarSla={atualizarMedicao}
                    onUpdatePage={AtualizarPagina}
                    atualizarFormularioAbas={AtualizarFormularioAbas}
                    atualizarFormulario={atualizarFormulario}
                    usuarioPodeEditar={usuarioPodeEditarMedicao}
                    usuarioLogadoGestorDoContratoMrn={usuarioLogadoGestorDoContratoMrn}
                    usuarioLogadoFiscalDoContratoMrn={usuarioLogadoFiscalDoContratoMrn}
                    usuarioLogadoFiscalAlternativoDoContratoMrn={usuarioLogadoFiscalAlternativoDoContratoMrn}
                    usuarioLogadoAdministradorAlternativoDoContratoMrn={
                      usuarioLogadoAdministradorAlternativoDoContratoMrn
                    }
                    usuarioLogadoAdministradorDoContratoMrn={usuarioLogadoAdministradorDoContratoMrn}
                    usuarioLogadoFiscalDoContratoFornecedor={usuarioLogadoFiscalDoContratoFornecedor}
                    usuarioLogadoGestorDoContratoFornecedor={usuarioLogadoGestorDoContratoFornecedor}
                    usuarioLogadoTecnicoMedicaoMrn={usuarioLogadoTecnicoMedicaoMrn}
                    usuarioResponsavelDiretoriaProp={usuarioResponsavelDiretoria}
                    usuarioResponsavelAreaProp={usuarioResponsavelArea}
                    usuarioResponsavelDepartamentoProp={usuarioResponsavelDepartamento}
                    codigoStatusMedicao={medicaoSelected.statusCodigo}
                    onCreateAba={handleCreateAba}
                    onRemoveAba={handleRemoveAba}
                  />
                </GridView>
              ) : (
                () => {}
              )}

              {hasPermission(['MEDICAO_QUANTITATIVA_VISUALIZAR_ABA']) &&
              isObjNotEmpty(medicaoSelected) &&
              usuarioPodeEditar ? (
                <GridView icon="printing-ruler" id="medicao" noform title="Medição">
                  <AbaMedicao
                    onUpdate={AtualizarAbaSla}
                    atualizarSla={atualizarMedicao}
                    onUpdatePage={AtualizarPagina}
                    atualizarFormularioAbas={AtualizarFormularioAbas}
                    atualizarFormulario={atualizarFormulario}
                    usuarioPodeEditar={usuarioPodeEditarMedicao}
                    usuarioLogadoGestorDoContratoMrn={usuarioLogadoGestorDoContratoMrn}
                    usuarioLogadoFiscalDoContratoMrn={usuarioLogadoFiscalDoContratoMrn}
                    usuarioLogadoFiscalAlternativoDoContratoMrn={usuarioLogadoFiscalAlternativoDoContratoMrn}
                    usuarioLogadoAdministradorAlternativoDoContratoMrn={
                      usuarioLogadoAdministradorAlternativoDoContratoMrn
                    }
                    usuarioLogadoAdministradorDoContratoMrn={usuarioLogadoAdministradorDoContratoMrn}
                    usuarioLogadoFiscalDoContratoFornecedor={usuarioLogadoFiscalDoContratoFornecedor}
                    usuarioLogadoGestorDoContratoFornecedor={usuarioLogadoGestorDoContratoFornecedor}
                    usuarioLogadoTecnicoMedicaoMrn={usuarioLogadoTecnicoMedicaoMrn}
                    usuarioResponsavelDiretoriaProp={usuarioResponsavelDiretoria}
                    usuarioResponsavelAreaProp={usuarioResponsavelArea}
                    usuarioResponsavelDepartamentoProp={usuarioResponsavelDepartamento}
                    codigoStatusMedicao={medicaoSelected.statusCodigo}
                    onCreateAba={handleCreateAba}
                    onRemoveAba={handleRemoveAba}
                  />
                </GridView>
              ) : (
                () => {}
              )}

              {isObjNotEmpty(medicaoSelected) &&
              medicaoSelected.possuiSla === true &&
              medicaoSelected.exibirAbaSla === true &&
              hasPermission(['MEDICAO_QUANTITATIVA_VISUALIZAR_ABA', 'MEDICAO_SLA_VISUALIZAR_ABA']) &&
              usuarioPodeEditar ? (
                <GridView icon="business-agreement" id="SLA" title="SLA" noform>
                  <AbaSla
                    onUpdate={AtualizarAbaMedicao}
                    atualizarMedicaoSla={atualizarSla}
                    onUpdatePage={AtualizarPagina}
                    atualizarFormularioAbas={AtualizarFormularioAbas}
                    atualizarFormulario={atualizarFormulario}
                    usuarioPodeEditar={usuarioPodeEditarMedicao}
                    usuarioLogadoGestorDoContratoMrn={usuarioLogadoGestorDoContratoMrn}
                    usuarioLogadoFiscalDoContratoMrn={usuarioLogadoFiscalDoContratoMrn}
                    usuarioLogadoFiscalAlternativoDoContratoMrn={usuarioLogadoFiscalAlternativoDoContratoMrn}
                    usuarioLogadoAdministradorAlternativoDoContratoMrn={
                      usuarioLogadoAdministradorAlternativoDoContratoMrn
                    }
                    usuarioLogadoAdministradorDoContratoMrn={usuarioLogadoAdministradorDoContratoMrn}
                    usuarioLogadoFiscalDoContratoFornecedor={usuarioLogadoFiscalDoContratoFornecedor}
                    usuarioLogadoGestorDoContratoFornecedor={usuarioLogadoGestorDoContratoFornecedor}
                    usuarioLogadoTecnicoMedicaoMrn={usuarioLogadoTecnicoMedicaoMrn}
                    usuarioResponsavelDiretoriaProp={usuarioResponsavelDiretoria}
                    usuarioResponsavelAreaProp={usuarioResponsavelArea}
                    usuarioResponsavelDepartamentoProp={usuarioResponsavelDepartamento}
                  />
                </GridView>
              ) : (
                () => {}
              )}

              {isObjNotEmpty(medicaoSelected) &&
              hasPermission(['PLANILHA_RATEIO_VISUALIZAR_ABA']) &&
              medicaoSelected.utilizaProcessoRateio === true &&
              medicaoSelected.possuiPlanilhaDeRateio === true &&
              medicaoSelected.statusConcluido === true ? (
                <GridView icon="data-database" noform id="rateio" title="Planilha de Rateio">
                  <AbaRateio medicaoSelecionada={medicaoSelected as ResumoMedicaoList} onUpdatePage={AtualizarPagina} />
                </GridView>
              ) : (
                () => {}
              )}

              {isObjNotEmpty(medicaoSelected) &&
              medicaoSelected.statusConcluido === true &&
              medicaoSelected.mostraAprovacaoEPagamento &&
              hasPermission(['MEDICAO_AUTORIZACAO_PAGAMENTO_VISUALIZAR_ABA']) ? (
                <GridView icon="shopping-money_bag" noform id="aprovacao" title="Aprovação e Pagamento">
                  <AutorizacaoPagamento
                    usuarioLogadoFinanceiroDoContratoFornecedor={usuarioLogadoFinanceiroFiscalGestorDoContratorFornecedor}
                  />
                </GridView>
              ) : (
                () => {}
              )}

              {hasPendenciasAba ? (
                <GridView icon="business-question_group" noform id="pendencias" title="Pendências">
                  <AbaPendencias onRemoveAba={handleRemoveAba} />
                </GridView>
              ) : (
                () => {}
              )}
              {isObjNotEmpty(medicaoSelected) && isMRN == true ? (
                <GridView icon="calendar-time_search" noform id="historico" title="histórico">
                  <AbaHistorico />
                </GridView>
              ) : (
                () => {}
              )}
              {isObjNotEmpty(medicaoSelected) ? (
                <GridView icon="data-timeline" noform id="statusProcesso" title="Status do Processo">
                  <AbaTimeLine />
                </GridView>
              ) : (
                () => {}
              )}
            </CompositeView>
          )}
        </CrudContext.Consumer>
      </CrudMasterDetailView>
    </>
  );
};

export default BoletimMe;
